import { Select } from 'antd';
import React, { useMemo } from 'react';

type SelectProps = React.ComponentProps<typeof Select>;

interface Option {
    value?: string;
    label: string;
}

interface SelectFormProps {
    label: string;
    values: (string | number | Option)[];
}

const SelectFormGroup: React.FC<SelectFormProps & SelectProps> = ({ label, values, ...selectProps }) => {
    const options = useMemo(
        () =>
            values.map((val) => {
                const value = typeof val === 'string' || typeof val === 'number' ? val : (val as Option).value;
                const label = typeof val === 'string' || typeof val === 'number' ? val : (val as Option).label;

                return (
                    <Select.Option key={`${value}`} value={value}>
                        {label}
                    </Select.Option>
                );
            }),
        [values]
    );

    return (
        <>
            <div style={{ gridColumn: 1 }}>
                <strong>{label}:</strong>
            </div>
            <div style={{ gridColumn: '2 / 6' }}>
                <Select style={{ width: '100%' }} {...selectProps}>
                    {options}
                </Select>
            </div>
        </>
    );
};

export default React.memo(SelectFormGroup);
export { Option };
